<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              Dados do Usuário
              <button
                class="btn btn-inform"
                data-container="body"
                data-toggle="popover"
                data-content="Pesquise os dados do cliente já cadastrado para poder solicitar um serviço."
              >
                <i class="fas fa-info"></i>
              </button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="nomeCliente">Nome:</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nomeCliente"
                      v-model="user.name"
                    />
                  </div>
                </div>
               
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="emailCliente">Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      id="emailCliente"
                      v-model="user.email"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="emailCliente">Senha:</label>
                    <input
                      type="password"
                      class="form-control"
                      id="emailCliente"
                      v-model="user.passwords"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="emailCliente">Confirmação de Senha:</label>
                    <input
                      type="password"
                      class="form-control"
                      id="emailCliente"
                      v-model="user.password_confirmation"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="emailCliente">Tipo de Acesso:</label>
                    <select v-model="user.type_access" class="form-control">
                      <option value="1">Solicitante de Atendimentos</option>
                      <option value="2">Gestor de Atendimentos</option>
                      <option value="3">Administrador</option>
                      <option value="4">Colaborador</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="block text-right">
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                    <router-link to="/users" class="btn btn-back">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  data() {
    return {
      errors: undefined,
      user: {},
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      departments: [],
      branches: [],
    };
  },
  computed: {
  },
  methods: {
    
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      if (self.user.id) {
        api += "/" + self.user.id;
        self.user._method = "PUT";
      }

      self.user.password = self.user.passwords;

      self.$http
        .post(api, self.user)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.errors = error.response.data;

          if (typeof self.errors === "object") {
            let html = "<ul>";

            $.each(self.errors, function (key, value) {
              html += "<li>" + value[0] + "</li>";
            });

            html += "</ul>";

            self.errors = html;
          }

          self.$message(null, self.errors, "error");
        });
    },
    getEntity: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getEntity(id);
    }
  },
  components: { vSelect },
};
</script>
<style scoped>
.addimg {
  width: 300px;
  height: 300px;
  border: 1px solid #23063a;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Users/Entity.vue